module.exports = __webpack_public_path__ + "img/flexible.f1c6b34e.svg";